import SectionHeading from '@/components/base/SectionHeading';
import ScrollReveal from '@/components/base/ScrollReveal';
import { analysisLearningStages } from '@/mocks/forexAnalysisPage';

const offsets = ['lg:mt-0', 'lg:mt-8', 'lg:mt-16', 'lg:mt-24'];

export default function LearningPath() {
  return (
    <section id="learning-path" className="scroll-mt-[7.5rem] md:scroll-mt-[9rem] border-b border-background-200 bg-background-100/70">
      <div className="mx-auto w-full max-w-7xl px-4 py-14 md:px-6 md:py-20 lg:px-10">
        <div className="flex flex-col gap-5 md:flex-row md:items-end md:justify-between md:gap-12">
          <SectionHeading
            eyebrow="เส้นทางการเรียนรู้"
            title="เส้นทางการเรียนรู้การวิเคราะห์ Forex"
            subtitle="เรียงลำดับสี่ขั้นตอนให้เห็นภาพว่าแต่ละเครื่องมือเข้ามาเสริมกันตอนไหน เริ่มจากอ่านราคาให้ออกก่อน แล้วค่อยเพิ่มเครื่องมือทีละชั้น"
          />
          <p className="max-w-xs shrink-0 text-xs leading-relaxed text-foreground-600 md:pb-2">
            ทำตามลำดับได้เลย แต่ละขั้นมีบทความในคลังด้านล่างให้เปิดอ่านต่อทันที
          </p>
        </div>

        <div className="relative mt-12 md:mt-16">
          <ol className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4 lg:gap-6">
            {analysisLearningStages.map((stage, index) => (
              <ScrollReveal as="li" key={stage.no} delay={index * 90} className={`relative flex flex-col self-start ${offsets[index]}`}>
                <div className="flex items-center gap-2.5">
                  <span
                    className={`relative z-10 flex h-9 w-9 shrink-0 items-center justify-center rounded-full border font-num text-xs font-semibold ${
                      index === 0
                        ? 'border-primary-500 bg-primary-500 text-background-50'
                        : 'border-background-300 bg-background-50 text-foreground-700'
                    }`}
                  >
                    {stage.no}
                  </span>
                  <span className="text-[11px] font-semibold uppercase tracking-wide text-foreground-500">
                    ขั้นที่ {index + 1}
                  </span>
                  <span className="h-px w-8 shrink-0 bg-background-300" aria-hidden="true" />
                </div>

                <div
                  className={`mt-4 flex flex-1 flex-col rounded-xl border p-5 ${
                    index % 2 === 0
                      ? 'border-background-200 bg-background-50'
                      : 'border-primary-100 bg-primary-50/60'
                  }`}
                >
                  <h3 className="font-heading text-base font-semibold leading-snug text-foreground-950 md:text-lg">
                    {stage.title}
                  </h3>
                  <p className="mt-2 text-sm leading-relaxed text-foreground-600">{stage.summary}</p>

                  <ul className="mt-4 flex flex-col gap-2 border-t border-background-200 pt-3.5">
                    {stage.points.map((point) => (
                      <li key={point} className="flex items-start gap-2 text-xs leading-relaxed text-foreground-700">
                        <i className="ri-check-line mt-0.5 text-sm text-primary-600" aria-hidden="true" />
                        <span>{point}</span>
                      </li>
                    ))}
                  </ul>

                  <div className="mt-auto border-t border-background-200 pt-3.5">
                    <span className="flex items-center gap-1.5 text-[11px] font-medium text-foreground-500">
                      <i className="ri-book-open-line text-sm" aria-hidden="true" />
                      {stage.lessonCount} บทความในหมวดนี้
                    </span>
                    <a
                      href={stage.target}
                      className="mt-2 flex items-center gap-1.5 text-xs font-semibold text-primary-700 transition-colors hover:text-primary-800"
                    >
                      {stage.linkLabel}
                      <i className="ri-arrow-right-line text-sm" aria-hidden="true" />
                    </a>
                  </div>
                </div>
              </ScrollReveal>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}